import { Burger } from '../core'

$.fn.Header = function() {
  let self = this

  if (self.data('header')) {
    return self.data('header')
  }

  self.burger = undefined
  self.cloned = undefined

  return function() {
    /* Burger */
    self.burger = new Burger('.burger', {
      onToggle: function() {
        if (self.burger.isExpanded) {
          $('body').addClass('--menu-open')
        } else {
          $('body').removeClass('--menu-open')
        }
      },
    })
    self.find('.header__burger > span').on('click', function(e) {
      self.burger.click(e)
    })

    /* Toggle menu items */
    $('.main-menu__item--parent > a, .main-menu__item--parent > span').each(function() {
      $(this).on('click', function(e) {
        e.preventDefault()
        if ($(this).closest('.main-menu__item--parent').hasClass('main-menu__item--parent-opened')) {
          $(this).closest('.main-menu__item--parent').removeClass('main-menu__item--parent-opened')
          $(this).closest('.main-menu__item--parent').find('.main-menu__sub-menu').slideUp({
            easing: 'easeInOutQuart',
          })
        } else {
          $(this).closest('.main-menu__item--parent').addClass('main-menu__item--parent-opened')
          $(this).closest('.main-menu__item--parent').find('.main-menu__sub-menu').slideDown({
            easing: 'easeInOutQuart',
          })
        }
      })
    })

    /* Scroll behavior */
    self.data('header', self)
    return self
  }()
}
